module.exports = __webpack_public_path__ + "img/img-main-bg06.bec6c2c2.png";